module.exports = __webpack_public_path__ + "static/media/ryj.e1f76b76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/ryj.png
// module id = 367
// module chunks = 0